import {
  AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter,
  HostListener, Input, OnInit, Output, ViewChild,
} from "@angular/core";
import { BusyState, EditFormValue, ScheduleForm } from "../models/schedule.model";

@Component({
  selector: "app-edit-schedule",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./edit-schedule.component.css"],
  templateUrl: "./edit-schedule.component.html",
})
export class EditScheduleComponent implements OnInit, AfterViewInit {
  @Input() form!: ScheduleForm;
  @Input() busy: BusyState = "idle";

  @Output() save = new EventEmitter<EditFormValue>();
  @Output() dismiss = new EventEmitter<void>();

  @ViewChild("firstField") firstField!: ElementRef<HTMLInputElement>;

  start = "";
  end = "";
  reason = "";
  removed = new Set<string>();

  ngOnInit(): void {
    this.start = this.form.window_start;
    this.end = this.form.window_end;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.firstField?.nativeElement.focus());
  }

  get saving(): boolean {
    return this.busy == "saving";
  }

  get windowError(): string {
    if (!this.start || !this.end) {
      return "Enter both a start and an end time.";
    }
    // "YYYY-MM-DDTHH:mm" strings compare correctly as text
    return this.end <= this.start ? "The end time must be after the start time." : "";
  }

  get allRemoved(): boolean {
    return this.form.servers.length > 0 && this.removed.size >= this.form.servers.length;
  }

  get hasChanges(): boolean {
    return this.start != this.form.window_start || this.end != this.form.window_end || this.removed.size > 0;
  }

  get canSave(): boolean {
    return !this.saving && this.hasChanges && !this.windowError && !this.allRemoved && this.reason.trim().length >= 3;
  }

  toggleServer(id: string, keep: boolean): void {
    keep ? this.removed.delete(id) : this.removed.add(id);
  }

  submit(): void {
    if (!this.canSave) {
      return;
    }
    this.save.emit({
      window_start: this.start,
      window_end: this.end,
      remove_instance_ids: Array.from(this.removed),
      reason: this.reason.trim(),
    });
  }

  close(): void {
    if (!this.saving) {
      this.dismiss.emit();
    }
  }

  @HostListener("document:keydown.escape")
  onEscape(): void {
    this.close();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}